import { FC, ReactNode, useEffect } from 'react';

import { useDispatch } from '@bonusly/events';

import { useChannelStore } from '../hooks/use-channel-store';
import { isChannelMessageType } from '../types';

type ChannelEventDistributorProps = {
	channel: string;
	children: ReactNode;
};

export const ChannelEventDistributor: FC<ChannelEventDistributorProps> = ({ channel, children }) => {
	const consumer = useChannelStore((state) => state.consumer);
	const dispatch = useDispatch();

	useEffect(() => {
		const sub = consumer.subscriptions.create(
			{ channel },
			{
				received: (msg: { event: string; data: any }) => {
					if (isChannelMessageType(msg)) {
						dispatch(`server:${msg.event}`, msg.data);
					}
				},
			}
		);

		return () => {
			sub.unsubscribe();
		};
	}, [channel, consumer, dispatch]);

	return <>{children}</>;
};
